import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ReferralService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalSettings extends React.Component<Props> {

	state = {
		form: {
			amount: '',
			type: Constants.REFERRAL_SETTING_TYPE.AMOUNT
		}
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					amount: this.props.item?.amount || '',
					type: this.props.item?.type || Constants.REFERRAL_SETTING_TYPE.AMOUNT
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		await ReferralService.admin.saveSettings({
			...this.state.form
		});
		this.props.onClose();
		Globals.showSuccess("Se ha modificado correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-referral-settings">
				<Input
					type="decimal"
					value={ this.state.form.amount }
					name="amount"
					label={ this.state.form.type == Constants.REFERRAL_SETTING_TYPE.AMOUNT ? 'Monto (USD)' : 'Porcentaje (%)' }
					onChange={ (e: any) => this.change(e) } />

				<div className="row">
					<div className="col-md-6">
						<div className="container-check" onClick={ () => this.setState({
							form: {
								...this.state.form,
								type: Constants.REFERRAL_SETTING_TYPE.AMOUNT
							}
						}) }>
							<div className={ `check ${ this.state.form.type == Constants.REFERRAL_SETTING_TYPE.AMOUNT ? 'active' : '' }` }></div>
							<p>Monto fijo</p>
						</div>
					</div>
					<div className="col-md-6">
						<div className="container-check" onClick={ () => this.setState({
							form: {
								...this.state.form,
								type: Constants.REFERRAL_SETTING_TYPE.PERCENT
							}
						}) }>
							<div className={ `check ${ this.state.form.type == Constants.REFERRAL_SETTING_TYPE.PERCENT ? 'active' : '' }` }></div>
							<p>Porcentaje</p>
						</div>
					</div>
				</div>
				<div className="text-center">
					<Button type="submit" onClick={ this.submit }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalSettings;